import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import benefitPlanPeriods, { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'

import useQueryParams from 'common/hooks/useQueryParams'

import { Card, Tabs } from 'common/components'
import { BenefitPlanPeriodDropDown, Col, Row, Skeleton } from 'common/components'

import { useQueryRequestV2 } from '../../../common/hooks'
import AllReimbursements from '../common/allReimbursements'
import Transactions from '../common/transactions'
import PerksExpenseApprovals from './expenseApprovals'
import PerksAllowanceBenefitSummary from './perksAllowanceBenefitSummary'
import ReimbursementsBalances from './reimbursementsBalances'
import PerksReimbursementDue from './reimbursementsDue'
import PerksReimbursementHistory from './reimbursementsDueHistory'

const PerksReimbursements: React.FC = () => {
  const queryParams = useQueryParams()
  const planPeriodIdQueryParam = queryParams.get('planPeriodId')
  const { t: translate } = useTranslation()
  //const params = useQueryParams()
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState<PlanPeriodDto | null>()
  const [reloadAllowanceBenefitSummary, setReloadAllowanceBenefitSummary] = useState<boolean>(false)
  const [tabActiveKey, setTabActiveKey] = useState(queryParams.get('tabActiveKey') ?? 'expense-approvals-due')

  const { data: planPeriods } = useQueryRequestV2<PlanPeriodDto[]>({
    initialState: null,
    queryFn: () => benefitPlanPeriods(),
  })

  useEffect(() => {
    if (planPeriods && planPeriods.length > 0) {
      const found = planPeriodIdQueryParam
        ? planPeriods.find((x) => x.id === planPeriodIdQueryParam)
        : planPeriods.find((x) => x.active == true)

      if (found) {
        setSelectedPlanPeriod(found)
      }
    }
  }, [planPeriods])
  return (
    <>
      <Skeleton active loading={!selectedPlanPeriod}>
        <Card
          title={[
            <h5 key="title">{translate('admin-dashboard.reimbursements.reimbursements-due.benefit-summary-title')}</h5>,
            <div key="summary" className="benefit_period">
              <BenefitPlanPeriodDropDown
                text="Benefit Period"
                defaultValue={planPeriodIdQueryParam}
                planPeriods={planPeriods}
                showStartDateAndEndDate={true}
                onPlanPeriodSelected={(planPeriodId: string) => {
                  const found = planPeriods.find((x) => x.id === planPeriodId)
                  setSelectedPlanPeriod(found)
                }}
              />
            </div>,
          ]}
          className="reimbursement_due_summary"
        >
          {selectedPlanPeriod && (
            <>
              <Row className="pb-24">
                <Col span={24}>
                  <PerksAllowanceBenefitSummary
                    planPeriodId={selectedPlanPeriod.id}
                    reload={reloadAllowanceBenefitSummary}
                    onReloaded={() => setReloadAllowanceBenefitSummary(false)}
                  />
                </Col>
              </Row>

              <Tabs
                activeKey={tabActiveKey}
                onTabClick={(tabKey) => {
                  setTabActiveKey(tabKey)
                }}
                panes={[
                  {
                    key: 'expense-approvals-due',
                    title: <h6>{translate('admin-dashboard.reimbursements.expense-approvals.title')}</h6>,
                    content: <PerksExpenseApprovals planPeriodId={selectedPlanPeriod.id} />,
                  },
                  {
                    key: 'balances',
                    title: <h6>{translate('admin-dashboard.reimbursements.reimbursements-due.balances-title')}</h6>,
                    content: <ReimbursementsBalances planPeriodId={selectedPlanPeriod.id} />,
                  },
                  {
                    key: 'reimbursements-due',
                    title: (
                      <h6>{translate('admin-dashboard.reimbursements.reimbursements-due.reimbursements-due-title')}</h6>
                    ),
                    content: (
                      <PerksReimbursementDue
                        planPeriodId={selectedPlanPeriod.id}
                        onApproved={() => setReloadAllowanceBenefitSummary(true)}
                      />
                    ),
                  },
                  {
                    key: 'reimbursements-history',
                    title: (
                      <h6>
                        {translate(
                          'admin-dashboard.reimbursements.perks-reimbursements-history.reimbursements-history-title',
                        )}
                      </h6>
                    ),
                    content: <PerksReimbursementHistory planPeriodId={selectedPlanPeriod.id} />,
                  },
                  {
                    key: 'transactions',
                    title: <h6>{translate('admin-dashboard.reimbursements.transactions.title')}</h6>,
                    content: <Transactions planPeriod={selectedPlanPeriod} />,
                  },
                  {
                    key: 'all-reimbursements',
                    title: <h6>{translate('admin-dashboard.reimbursements.all-submissions.title')}</h6>,
                    content: <AllReimbursements planPeriodId={selectedPlanPeriod.id} />,
                  },
                ]}
              />
            </>
          )}
        </Card>
      </Skeleton>
    </>
  )
}

export default PerksReimbursements
